"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.23.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import '../../../styled-system/css/css.mjs';
import '../../../styled-system/helpers.mjs';
import { sva } from '../../../styled-system/css/sva.mjs';

const comboboxContainerRecipe = sva({
  className: "combobox-container",
  slots: ["root"],
  base: {
    root: {
      display: "inline-flex",
      verticalAlign: "middle",
      w: "fit-content",
      maxW: "full",
      h: "full",
      flexGrow: "1",
      cursor: "pointer",
      px: "1",
      "&:hover:not(:has([data-editor-tag='true']:hover))": {
        "& p": {
          bg: "slate.2"
        }
      },
      _expanded: {
        "& p": {
          bg: "slate.2"
        }
      }
    }
  },
  variants: {
    disabled: {
      true: {
        root: {
          bg: "slate.2",
          cursor: "initial"
        }
      },
      false: {}
    },
    level: {
      editor: {},
      tag: {
        root: {
          p: "0",
          mx: "3px",
          '[contenteditable="true"] &': {
            my: "3px"
          }
        }
      }
    }
  }
});
const ComboboxContainer = forwardRef(({ children, disabled, className, level, ...props }, ref) => {
  const styles = comboboxContainerRecipe({ disabled, level });
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "combobox",
      className: clsx(styles.root, className),
      ref,
      "aria-disabled": disabled,
      "aria-readonly": disabled,
      ...props,
      children
    }
  );
});

export { ComboboxContainer, comboboxContainerRecipe };
